const productMenu = document.getElementById('VeProductMenu');
const productMenuTrigger = document.querySelector('[data-product-menu-open]');
if (productMenu && productMenuTrigger) {
  const closeMenu = () => productMenu.close();
  productMenuTrigger.addEventListener('click', () => {
    productMenu.showModal();
    productMenuTrigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('ve-product-menu-open');
  });
  productMenu.querySelector('[data-product-menu-close]')?.addEventListener('click', closeMenu);
  productMenu.addEventListener('click', event => {
    if (event.target !== productMenu) return;
    const rect = productMenu.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeMenu();
  });
  productMenu.addEventListener('close', () => {
    productMenuTrigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('ve-product-menu-open');
    productMenuTrigger.focus({preventScroll:true});
  });
  productMenu.querySelector('[data-product-menu-language]')?.addEventListener('change', event => event.target.form.requestSubmit());
}
const refreshProductCart = async () => {
  const cartLink = document.querySelector('[data-product-cart]');
  if (!cartLink) return;
  try {
    const cartUrl = new URL(cartLink.href);
    cartUrl.pathname += '.js';
    const response = await fetch(cartUrl, {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) return;
    const cart = await response.json();
    if (!Number.isFinite(cart.item_count)) return;
    document.querySelectorAll('[data-product-cart-count]').forEach(count => count.textContent = String(cart.item_count));
    cartLink.setAttribute('aria-label', `${cartLink.dataset.cartLabel} (${cart.item_count})`);
  } catch {}
};
window.addEventListener('pageshow', event => { if (event.persisted) refreshProductCart(); });
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refreshProductCart(); });
